import { Box, TextField } from "@mui/material";

function ThirdStep() {
  return(
    <>
    <h1 className="text-[color:--primary-color] text-center uppercase font-extrabold text-2xl pb-6">comece a gerenciar seu coworking</h1>

    <Box className="w-96 m-auto flex flex-col justify-center items-center my-1 lg:my-3"
      sx={{ '& > :not(style)': { m: 1 } }}
      component="form"
      noValidate
      autoComplete="off">

      <TextField className="bg-[#F5F5F5] rounded-lg w-80 lg:w-96" id="filled-basic" variant="filled" label="Lorem Ipsum" placeholder="" />

      <TextField className="bg-[#F5F5F5] rounded-lg w-80 lg:w-96" id="filled-basic" variant="filled" label="Lorem Ipsum" placeholder="" />

      <div className="bg-[#B0B0B0]/5 text-center p-5 w-96 rounded-lg shadow-md">
        <p className="font-semibold pb-1">Documentos de Comprovação de Vínculo</p>
        <button className="bg-[#f5f5f5] my-4 text-xs font-semibold py-1 border-2 border-dotted border-[color:--secondary-color-hover] rounded-lg w-80 text-[color:--secondary-color-hover]">Exportar arquivo</button>
      </div>

    </Box></>
  )
}

export default ThirdStep;